/**
 * Kiểu + nhãn chính sách dùng AI (TT 83 C5 — chức năng #5). Mirror BE
 * `apps.assessment.services.ai_policy` + `AiDeclarationInputSerializer`.
 */
export type AiPolicyLevel = "prohibited" | "allowed_with_declaration" | "unrestricted";

export interface StudentAiPolicy {
  level: AiPolicyLevel;
  student_notice: string;
  allowed_tools: string;
  tutor_blocked: boolean;
  declaration_required: boolean;
}

export interface AiDeclarationInput {
  used_ai: boolean;
  tools: string[];
  purposes: string[];
  detail: string;
}

export const AI_LEVEL_LABEL: Record<AiPolicyLevel, string> = {
  prohibited: "Cấm dùng AI",
  allowed_with_declaration: "Được dùng AI, phải khai báo",
  unrestricted: "Được dùng AI tự do",
};

export const AI_LEVEL_COLOR: Record<AiPolicyLevel, string> = {
  prohibited: "red",
  allowed_with_declaration: "gold",
  unrestricted: "green",
};

export const AI_PURPOSE_LABEL: Record<string, string> = {
  y_tuong: "Gợi ý ý tưởng",
  dan_y: "Lập dàn ý",
  viet: "Viết nội dung",
  sua_ngu_phap: "Sửa chính tả/ngữ pháp",
  dich: "Dịch",
  code: "Viết/sửa code",
  khac: "Khác",
};
